import { createSlice } from '@reduxjs/toolkit';
import UploadManager from "./uploadManager.js";

// 初始状态
const initialState = {
  manager: UploadManager,
};

// 创建 slice
export const uploadSlice = createSlice({
  name: 'upload',
  initialState,
})

export const uploadManager = (state) => state.upload.manager;
export default uploadSlice.reducer;